import * as React from 'react';

import {Nut_PhoneCaller} from 'nutshell-core/settings-constants';

import type {ClickToCallPropsType} from 'shells/row/custom-field-row/custom-field-row';

import {handleCall} from '../../../phone/handle-call';

import {useGetSetting} from '../../core/use-get-setting';

export function useGetClickToCallProps(entityId: string): ClickToCallPropsType | null | undefined {
    const {setting: phoneCallerType, isLoading: isLoadingPhoneCallerType} = useGetSetting({
        settingName: Nut_PhoneCaller.USER_TYPE_SETTINGS_KEY,
        isGlobal: false,
    });

    const clickToCallProps = React.useMemo(() => {
        return isLoadingPhoneCallerType
            ? null
            : {
                  phoneCallerType: phoneCallerType && phoneCallerType.value,
                  entityId,
                  handleCall,
              };
    }, [phoneCallerType, entityId, isLoadingPhoneCallerType]);

    return clickToCallProps;
}
